import React from 'react';
import { t } from 'i18next';

import { PageContentS, PageHeaderS, PageWrapS, Paragraph, SectionHeaderS } from './legalPagesS';

import withGATracker from '../../../utils/enhancers/withGATracker';

export const getNumberWithStyles = number => `<span style="color: #1D1D8C; font-size: 16px">${number}</span>`;

export const getNumbersToReplace = (max, decimalPart) => {
  let data = {};
  new Array(max).fill(1).map((e, i) => data[`${i + 1}`] = getNumberWithStyles(`${decimalPart}.${i + 1}`));
  return data;
};

const AGB = () => (
  <PageWrapS>
    <PageContentS>

      <PageHeaderS>{t('agb.pageTitle')}</PageHeaderS>
      <SectionHeaderS> {t('agb.firstSection.header')}</SectionHeaderS>
      <Paragraph>{t('agb.firstSection.text')}</Paragraph>

      <SectionHeaderS>{t('agb.secondSection.header')}</SectionHeaderS>
      <Paragraph>{t('agb.secondSection.text')}</Paragraph>

      <SectionHeaderS>{t('agb.thirdSection.header')}</SectionHeaderS>
      <Paragraph
        dangerouslySetInnerHTML={{
          __html: t('agb.thirdSection.text', {
            ...getNumbersToReplace(9, 3),
            redPoint: '<span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: #d90e4b" ></span>',
            interpolation: { escapeValue: false }
          } )
        }} />

      <SectionHeaderS>{t('agb.forthSection.header')}</SectionHeaderS>
      <Paragraph>{t('agb.forthSection.text')}</Paragraph>

      <SectionHeaderS>{t('agb.fifthSection.header')}</SectionHeaderS>
      <Paragraph>{t('agb.fifthSection.text')}</Paragraph>

      <SectionHeaderS>{t('agb.sixthSection.header')}</SectionHeaderS>
      <Paragraph
        dangerouslySetInnerHTML={{
          __html: t('agb.sixthSection.text', {
            ...getNumbersToReplace(5, 6),
            interpolation: { escapeValue: false }
          } )
        }} />

      <SectionHeaderS>{t('agb.seventhSection.header')}</SectionHeaderS>
      <Paragraph>{t('agb.seventhSection.text')}</Paragraph>

      <SectionHeaderS>{t('agb.eighthSection.header')}</SectionHeaderS>
      <Paragraph>{t('agb.eighthSection.text')}</Paragraph>

      <SectionHeaderS>{t('agb.ninethSection.header')}</SectionHeaderS>
      <Paragraph>{t('agb.ninethSection.text')}</Paragraph>

    </PageContentS>
  </PageWrapS>
);

export default withGATracker(AGB);